module.exports = __webpack_public_path__ + "media/assets/svg/components/dots-5-d7493490b47b697e08fd8cd98eb8f949.svg";